import AppConstants from '../gorillaboy/AppConstants';
import {Task} from '../types/TaskTypes';
import {ISelectionManager, ISelectedItem} from '../types/selectionManager'
import {RootScope} from '../types/angular-types';
import SignalProvider from '../gorillaboy/SignalProvider';

import * as _ from 'lodash-es';


export class TaskSelectionManager implements ISelectionManager {
    private taskMap: Map<string, Task>;
    private selectedTaskIds: Set<string>;
    private $rootScope: RootScope;
    constructor($rootScope: RootScope) {
        this.taskMap = new Map<string, Task>();
        this.selectedTaskIds = new Set();
        this.$rootScope = $rootScope;
    }

    public setTaskList(tasks: Task[]) {
        this.taskMap.clear();
        tasks.forEach((task) => {
            this.taskMap.set(task.Id, task);
        });
    }

    public initTaskList(tasks: Task[]) {
        this.clearSelected();
        this.setTaskList(tasks);
    }

    public markAsSelected(type: string, itemId: string) {
        if (type === AppConstants.ResourceTypes.TASK) {
            this.selectedTaskIds.add(itemId);
            this.$rootScope.$broadcast(SignalProvider.Selection.TaskSelected);
        }
    }

    public markAsSelectedExclusively(type: string, itemId: string) {
        if (type === AppConstants.ResourceTypes.TASK) {
            this.selectedTaskIds.clear();
            this.markAsSelected(type, itemId);
        }
    }

    public unselect(type: string, itemId: string) {
        if (type === AppConstants.ResourceTypes.TASK) {
            this.selectedTaskIds.delete(itemId);
            this.$rootScope.$broadcast(SignalProvider.Selection.TaskUnselected);
        }
    }

    public clearSelected() {
        this.selectedTaskIds.clear();
        this.$rootScope.$broadcast(SignalProvider.Selection.TaskUnselectedAll);
    }

    public getTotalSelectedItemCount() {
        return this.selectedTaskIds.size;
    }
    public getRightClickMenuType() {
        if (this.selectedTaskIds.size === 1) {
            return AppConstants.RightClickMenus.TASK_SELECTED;
        } else if (this.selectedTaskIds.size > 1) {
            return AppConstants.RightClickMenus.MULTI_TASK_SELECTED;
        }
        return null;
    }
    public getSelectedItems() {
        let selectedItems = [];
        this.selectedTaskIds.forEach(function(taskId) {
            let selectedItem = {
                type: AppConstants.ResourceTypes.TASK,
                item: this.taskMap.get(taskId)
            } as ISelectedItem;
            selectedItems.push(selectedItem);
        }.bind(this));
        return selectedItems;
    }
    public getItemType(itemId: string) {
        // Assume it only used for task
        return AppConstants.ResourceTypes.TASK;
    }
    public isSelected(type: string, itemId: string) {
        if (type === AppConstants.ResourceTypes.TASK) {
            return this.selectedTaskIds.has(itemId);
        }
        return false;
    }
    public selectAll(){
        this.selectedTaskIds = new Set(this.taskMap.keys());
        this.$rootScope.$broadcast(SignalProvider.Selection.TaskSelectedAll);
    }
}